export default "__VITE_ASSET__CYZEKeP8__";